import { useCallback } from "react";
import { useFetchauthApis } from "./useFetchAuthApis";

export default function useAuthApis() {
  const { loading, data, apiError, fetchData } = useFetchauthApis();
  const loginWithGmail = useCallback(async ({ payload }) => {
    const url = "staff_login";
    fetchData({ url, method: "POST", payload });
  }, [fetchData]);

  return {
    loginWithGmail,
    loading,
    apiError,
    data,
    fetchData
  };
}
